<template>
  <div :class="['ui segment secondary form', customClass, { inverted: theme }]">
      <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ContainerBody',
  props: ['customClass'],
  data() {
    return {
      theme: localStorage.getItem('theme'),
    };
  },
};

</script>
